const model = [
  {
    key: 'campaignId',
    label: 'Campaign Id',
    minWidth: 100,
  },
  {
    key: 'campaignName',
    label: 'Campaign Name',
    minWidth: 150,
    type: 'string',
  },
  {
    key: 'campaignWindow',
    label: 'Window',
    minWidth: 100,
  },
  { key: 'accountCode', label: 'Account Code', minWidth: 110 },
  {
    key: 'email',
    label: 'Email',
    minWidth: 100,
  },
  {
    key: 'amount',
    label: 'Amount',
    minWidth: 100,
  },
  {
    key: 'category',
    label: 'Category',
    minWidth: 100,
  },
  {
    key: 'reason',
    label: 'Reason',
    minWidth: 100,
  },
  {
    key: 'posted',
    label: 'Posted',
    minWidth: 100,
  },
  {
    key: 'modifiedBy',
    label: 'Last Modified By',
    minWidth: 150,
  },
  {
    key: 'modifiedAt',
    label: 'Last Modified At',
    minWidth: 150,
  },
];

export default model;
